/* eslint-disable max-lines-per-function */
/**
 * @file  Videos
 * @author yuanyaojia@baijia.com
 * @date 2021-06-17
 */

import React, {useEffect, useState, useContext} from 'react';
import {message, Pagination} from 'antd';
import {useHistory} from 'react-router-dom';
import {getListByChannelCode, getInfoById, getVideoPlayUrl} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

function Videos() {
    const history = useHistory();
    const [channelVideos, setChannelVideos] = useState([]);
    const [total, setTotal] = useState(0);
    const [playVideoUrl, setPlayVideoUrl] = useState('');

    const [pageDto, setPageDto] = useState({
        pageNum: 1,
        pageSize: 9
    });

    const {pageNum} = pageDto;
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
        getListByChannelCode({code: 'channel_ir_videos', pageDto})
            .then(({data}) => {
                const {list, total} = data;
                setChannelVideos(list);
                setTotal(total);
            })
            .catch(() => {
                message.error('获取视频列表失败');
            });
    }, [pageDto]);

    function handleToDetail(e) {
        const {uid} = e.currentTarget.dataset;
        history.push(`/video/detail/${uid}`);
    }

    function handleToVideo(e) {
        const {uid} = e.currentTarget.dataset;
        getInfoById({uid})
            .then(({data}) => {
                const {subChannelCode, content: {video: {id: videoId}}} = data;
                if (subChannelCode === 'channel_ir_videos') {
                    getVideoPlayUrl({videoId})
                        .then(({data}) => {
                            const {playVideoUrl} = data;
                            setPlayVideoUrl(playVideoUrl);
                        })
                        .catch(() => {
                            message.info('获取视频播放链接失败');
                        });
                }
            })
            .catch(() => {
                message.error('获取视频详情失败');
            });
        if (playVideoUrl) {
            window.open(playVideoUrl);
        }
    }

    function handlePageChange(page, pageSize) {
        setPageDto({
            pageNum: page,
            pageSize
        });
    }

    return (
        <div className="video-list">
            {
                isMobile && (
                    <>
                        <div className="video-list-title">
                            Videos
                        </div>
                    </>
                )
            }
            <div className="video-content">
                {
                    channelVideos?.map(item => (
                        <div key={item.id} className="video-template">
                            <div
                                role="button"
                                tabIndex={0}
                                data-id={item.id}
                                data-uid={item.uid}
                                data-source={item.content.title}
                                className="video-content-single"
                                onClick={isMobile ? handleToVideo : handleToDetail}
                            >
                                <div className="video-content-img">
                                    <img
                                        className="video-content-cover"
                                        src={item.content.prefaceUrl
                                            ? item.content.prefaceUrl.url
                                            : item.content.video.prefaceUrl}
                                        alt="封面图"
                                    />
                                </div>
                                <div className="video-title">
                                    {item.content.title}
                                </div>
                                <div className="video-time">
                                    {item.content.time}
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>

            {
                !isMobile && (
                    <div className="video-pagination">
                        <Pagination
                            onChange={handlePageChange}
                            defaultPageSize={9}
                            defaultCurrent={1}
                            pageSizeOptions={['9', '18', '27', '36']}
                            total={total}
                            current={pageNum}
                            showSizeChanger
                            hideOnSinglePage
                        />
                    </div>
                )
            }
        </div>
    );
}

export default Videos;
